export const UserStatus = {
  READY: "READY",
  NOT_READY: "NOT_READY",
  BIOBREAK: "BIOBREAK",
  LUNCHBREAK: "LUNCHBREAK",
  TRAINING: "TRAINING",
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const statusOptions = [
  { value: UserStatus.NOT_READY, label: "Not Ready" },
  { value: UserStatus.READY, label: "Ready" },
  { value: UserStatus.BIOBREAK, label: "Bio-break" },
  { value: UserStatus.LUNCHBREAK, label: "Lunch Break" },
  { value: UserStatus.TRAINING, label: "Training" },
];

export const UserRoles = {
  AGENT: "AGENT",
  SUPERVISOR: "SUPERVISOR",
  ADMIN: "ADMIN",
};

export const UserBU = {
  PV: "PV",
  CV: "CV",
};

export const UserGroup = {
  SALES: "SALES",
  SERVICE: "SERVICE",
  OPPORTUNITY: "OPPORTUNITY",
  FLEET_EDGE: "FLEET_EDGE"
};

export const MessageType = {
  TEXT: "TEXT",
  BUTTON: "BUTTON",
  WHATSAPP_TEMPLATE: "WHATSAPP_TEMPLATE",
  WHATSAPP_LIST: "WHATSAPP_LIST",
  TEXT_LIST_WITH_LINKS: "TEXT_LIST_WITH_LINKS",
  IMAGE: "IMAGE",
  DOCUMENT: "DOCUMENT",
  VIDEO: "VIDEO",
  AUDIO: "AUDIO",
  VOICE: "VOICE",
  DELIVERY_NOTIFICATION: "DELIVERY_NOTIFICATION",
  SEEN_NOTIFICATION: "SEEN_NOTIFICATION",
  LOCATION: "LOCATION",
  SUGGESTION: "SUGGESTION",
  CUSTOM: "CUSTOM",
  INTERACTIVE_LIST_REPLY: "INTERACTIVE_LIST_REPLY"
};

export const UserChannel = {
  WHATSAPP: "WHATSAPP",
  TELEGRAM: "TELEGRAM",
  TEAMS: "TEAMS",
  WHATSAPP_CV_SALES_BOT: "WHATSAPP_CV_SALES_BOT",
  FLEET_EDGE: "FLEET_EDGE",
  FLEET_EDGE_AGENT: "FLEET_EDGE_AGENT",
};
export const TableTitle = {
  SalesOp: "Sales Opportunities",
  RaiseQuery: "Raise Query",
  CallbackRequest: "Callback Request",
};
//adding comment for re-deployment.
export const DocumentTypes = [
  { title: "BROCHURE", value: "BROCHURE" },
  { title: "PRODUCT IMAGE", value: "PRODUCT_IMAGE" },
  { title: "CUSTOMER CARD", value: "CUSTOMER_CARD" },
  { title: "SALES PITCH", value: "SALES_PITCH" },
  { title: "TESTIMONIALS", value: "TESTIMONIALS" },
  { title: "FUEL TRIALS", value: "FUEL_TRIALS" },
  { title: "GRAHAK SAMVAAD", value: "GRAHAK_SAMVAAD" },
  { title: "WORKSHOP LIST", value: "WORKSHOP_LIST" },
  { title: "CAMPAIGNS", value: "CAMPAIGNS" },
  { title: "SAMPOORNA SEVA", value: "SAMPOORNA_SEVA" },
  { title: "WHATSAPP BROADCAST", value: "WHATSAPP_BROADCAST" }
]


export const FilterTextName = {
  RecentOpty: "Recent Opty",
  FilterQuery: "Filter Query",
  FilterRequest: "Filter Request",
};


export const QueryStatus = {
  NOT_STARTED: "NOT_STARTED",
  WORK_IN_PROGRESS: "WORK_IN_PROGRESS",
  CLOSED: "CLOSED"
}


export const CallBackStatus = {
  NOT_STARTED: "NOT_STARTED",
  WORK_IN_PROGRESS: "WORK_IN_PROGRESS",
  NOT_REACHABLE: "NOT_REACHABLE",
  NOT_PICKED_UP: "NOT_PICKED_UP",
  CALL_CLOSED: "CALL_CLOSED"
}

export const getFileScenario = {
  CUSTOMER_QUERY: "CUSTOMER_QUERY",
}